(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ilift-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ilift-reviews')) {
  customElements.define('ilift-reviews', class extends HTMLElement {
    connectedCallback() {
      this.timer = setTimeout(() => this.setup(), 0);
    }

    setup() {
      const track = this.querySelector('.ilr-track');
      if (!track || !track.children.length) return;

      this.abort = new AbortController();
      const signal = this.abort.signal;

      const listen = (node, event, fn, options = {}) => {
        node.addEventListener(event, fn, { ...options, signal });
      };

      const pause = this.querySelector('[data-pause]');
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = this.dataset.auto === 'true';
      const speed = Number(this.dataset.speed) || 18;

      let paused = motion.matches;
      let hovering = false;
      let touching = false;
      let visible = false;
      let waitUntil = 0;
      let direction = 1;
      let position = track.scrollLeft;
      let last = 0;

      const delay = () => {
        waitUntil = performance.now() + 5000;
      };

      const maximum = () => {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      };

      const controls = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum() - 1;
        pause.hidden = !autoplay || maximum() <= 1;
        pause.textContent = paused ? 'Resume' : 'Pause';
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute(
          'aria-label',
          paused
            ? 'Resume automatic scrolling'
            : 'Pause automatic scrolling'
        );
      };

      listen(pause, 'click', () => {
        paused = !paused;
        delay();
        controls();
      });

      const move = amount => {
        delay();
        track.scrollBy({
          left: amount * track.clientWidth * .86,
          behavior: motion.matches ? 'auto' : 'smooth'
        });
      };

      listen(previous, 'click', () => move(-1));
      listen(next, 'click', () => move(1));

      listen(track, 'keydown', event => {
        delay();

        if (
          event.key === 'ArrowRight' ||
          event.key === 'ArrowLeft'
        ) {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });

      listen(track, 'wheel', delay, { passive: true });

      listen(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse') hovering = true;
      });

      listen(this, 'pointerleave', () => {
        hovering = false;
        delay();
      });

      listen(track, 'pointerdown', () => {
        touching = true;
        delay();
      }, { passive: true });

      const release = () => {
        if (touching) {
          touching = false;
          delay();
        }
      };

      listen(window, 'pointerup', release, { passive: true });
      listen(window, 'pointercancel', release, { passive: true });
      listen(this, 'focusout', delay);
      listen(track, 'scroll', controls, { passive: true });

      listen(motion, 'change', () => {
        paused = motion.matches;
        controls();
      });

      this.resize = new ResizeObserver(controls);
      this.resize.observe(track);

      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
      });
      this.observer.observe(this);

      const frame = now => {
        const elapsed = Math.min(now - (last || now), 50) / 1000;
        last = now;

        const canMove =
          autoplay &&
          !paused &&
          !hovering &&
          !touching &&
          visible &&
          !document.hidden &&
          !this.querySelector(':focus-visible') &&
          now >= waitUntil &&
          maximum() > 1;

        if (canMove) {
          if (Math.abs(track.scrollLeft - position) > 2) {
            position = track.scrollLeft;
          }

          position += direction * speed * elapsed;

          if (position >= maximum()) {
            position = maximum();
            direction = -1;
            waitUntil = now + 1500;
          }

          if (position <= 0) {
            position = 0;
            direction = 1;
            waitUntil = now + 1500;
          }

          track.scrollLeft = position;
        } else {
          position = track.scrollLeft;
        }

        this.frame = requestAnimationFrame(frame);
      };

      controls();
      this.frame = requestAnimationFrame(frame);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
